<template>
  
</template>

<script>
export default {
  created () {
    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user.roles && user.roles.includes('ROLE_PACIENTE')) {
        console.log('created ' + user.roles)
        this.$router.push({name: 'ResultadoPacienteCardList'})
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Hello.vue?42531490